import { createNativeStackNavigator } from "@react-navigation/native-stack";
import MeasuringPointScreen from "../screens/firmadminmeasuringptscreen";
import ChangeBranchScreen from "../screens/changebranchscreen";
import ChangeMeasuringPointScreen from "../screens/changemeasuringptscreen";
import ChangeBoardScreen from "../screens/changeboardscreen";
import { pageTitle } from "../context/helper";

const Stack = createNativeStackNavigator();

const MeasuringPointStack = () => {
    return (
         <Stack.Navigator screenOptions={{headerShown: false}}>
        <Stack.Screen
          component={MeasuringPointScreen}
          name="MeasuringPointMain"
          options={{ title: pageTitle("Messstellen") }}
          />
        <Stack.Screen
          component={ChangeBranchScreen}
          name="ChangeBranch"
          options={{ title: pageTitle("Einstellungen Standort") }}
          />
        <Stack.Screen
          component={ChangeMeasuringPointScreen}
          name="ChangeMeasuringPoint"
          options={{ title: pageTitle("Einstellungen Messstelle") }}
          />
        <Stack.Screen
          component={ChangeBoardScreen}
          name="ChangeBoard"
          options={{ title: pageTitle("Einstellungen Sensorbox") }}
          />
      </Stack.Navigator>
 
    )
}

export default MeasuringPointStack;